import React, { useMemo } from "react";
import { Col, Row } from "reactstrap";
import DashPanel from "../common/DashPanel";
import Tooltip from "../common/Tooltip";
import EmptyState from "../common/EmptyState";
import GlobalCustomTable from "../../../../../GlobalCustomTable";
import { fmtLogDate } from "../../utils/formatters";
import { T } from "../../constants/theme";
import { recentLogs } from "../../data/dashboardMockData";

const RecentActivitySection = ({ logs, loading }) => {
  const recentActivityColumns = useMemo(
    () => [
      {
        text: "Date & Time",
        dataField: "Transactiontime",
        formatter: (v, row) => (
          <span style={{ fontSize: "12px", color: T.muted }}>
            {fmtLogDate(row.Transactiontime || row.TransactionDate)}
          </span>
        ),
      },
      {
        text: "User",
        dataField: "UserName",
        formatter: (v) => <span style={{ fontSize: "12px", fontWeight: 600 }}>{v}</span>,
      },
      {
        text: "Type",
        dataField: "TransactionType",
        formatter: (v) => {
          const isEx = v === "Exception";
          return (
            <span
              style={{
                fontSize: "11px",
                padding: "2px 8px",
                borderRadius: "4px",
                fontWeight: 600,
                background: isEx ? "#fde8e8" : "#e8f5e9",
                color: isEx ? "#c62828" : "#2e7d32",
              }}
            >
              {v}
            </span>
          );
        },
      },
      {
        text: "Details",
        dataField: "TransactionDetails",
        formatter: (v) => (
          <Tooltip content={v}>
            <span style={{ fontSize: "12px", color: T.muted, cursor: "default" }}>
              {v && v.length > 60 ? v.substring(0, 60) + "…" : v}
            </span>
          </Tooltip>
        ),
      },
      {
        text: "IP / Browser",
        dataField: "IPaddress",
        formatter: (v) => <span style={{ fontSize: "11px", color: "#888" }}>{v}</span>,
      },
    ],
    []
  );

  const tableData = (logs.length > 0 ? logs : recentLogs)
    .slice(0, 15)
    .map((item, idx) => ({ ...item, id: item.id || idx + 1 }));

  return (
    <Row>
      <Col xl={12}>
        <DashPanel
          title="Recent Activity & Exception Log"
          icon="bx bx-list-ul"
          iconColor={T.blue}
          loading={loading}
        >
          <GlobalCustomTable
            keyField="id"
            data={tableData}
            columns={recentActivityColumns}
            search
            classes="table table-bordered table-hover"
            noDataIndication={<EmptyState text="No recent activity found." />}
          />
        </DashPanel>
      </Col>
    </Row>
  );
};

export default RecentActivitySection;
